"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _reduxObservable = require("redux-observable");

var _of = require("rxjs/observable/of");

var _mergeMap = require("rxjs/operators/mergeMap");

var _publishReplay = require("rxjs/operators/publishReplay");

var _refCount = require("rxjs/operators/refCount");

var _concat = require("rxjs/operators/concat");

function _default(_ref) {
  var scopedEpics = _ref.scopedEpics,
      metaInitiatingActionType = _ref.metaInitiatingActionType,
      mapStateAndMetaActionToInitiatingActions = _ref.mapStateAndMetaActionToInitiatingActions;
  return function ($action, store) {
    return $action.ofType(metaInitiatingActionType).pipe((0, _mergeMap.mergeMap)(function (action) {
      var combinedEpic = _reduxObservable.combineEpics.apply(void 0, (0, _toConsumableArray2.default)(scopedEpics));

      var $initiatingAction = _reduxObservable.ActionsObservable.from(mapStateAndMetaActionToInitiatingActions(store.getState(), action));

      var $resultAction = combinedEpic($initiatingAction, store).pipe((0, _publishReplay.publishReplay)(), (0, _refCount.refCount)());
      return $initiatingAction.pipe((0, _concat.concat)($resultAction), (0, _mergeMap.mergeMap)(function (actions) {
        return (0, _of.of)(actions);
      }));
    }));
  };
}

module.exports = exports.default;